import React, { useState } from 'react';

// 橫幅/輪播圖：圖片載入前顯示柔和中性佔位（非紫色，避免閃色），
// 載入完成後淡入。children 為疊在圖上的文字/漸層層。
export default function BannerImage({ src, height, radius = 0, children, style = {}, imgStyle = {} }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height,
        borderRadius: radius,
        overflow: 'hidden',
        background: '#EDEFF8', // 柔和中性佔位（不用品牌紫，避免載入前閃一下）
        ...style,
      }}
    >
      {src ? (
        <img
          src={src}
          alt=""
          loading="lazy"
          onLoad={() => setLoaded(true)}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            opacity: loaded ? 1 : 0,
            transition: 'opacity .45s ease',
            ...imgStyle,
          }}
        />
      ) : null}
      {children}
    </div>
  );
}
